import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../utils';

export const watercraftApiSlice = createApi({
  baseQuery: axiosBaseQuery({
    baseURL: `${process.env.REACT_APP_WATERCRAFT_URL}`,
  }),
  reducerPath: 'watercraftApi',
  tagTypes: [],
  endpoints: () => ({}),
});
